import React, { useState } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { FaWhatsapp } from "react-icons/fa";
import logo from "../../assets/publicpageimg/skillediton-logo1.png";

import "./Header.css";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  const closeMenu = () => setExpanded(false);

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      className="skilledition-main-header"
    >
      <Container>
        <Navbar.Brand
          as={Link}
          to="/"
          className="skilledition-main-header-logo"
          onClick={closeMenu}
        >
          <img
            src={logo}
            alt="Skilledition Logo"
            className="skilledition-main-header-logo-img"
          />
        </Navbar.Brand>

        <Navbar.Toggle
          className="skilledition-main-header-toggle"
          onClick={() => setExpanded(expanded ? false : "expanded")}
        />

        <Navbar.Collapse className="skilledition-main-header-collapse">
          <Nav className="ms-auto skilledition-main-header-nav">
            <Nav.Link
              as={Link}
              to="/"
              className={location.pathname === "/" ? "active" : ""}
              onClick={closeMenu}
            >
              Home
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/courses"
              className={location.pathname === "/courses" ? "active" : ""}
              onClick={closeMenu}
            >
              Courses
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/internship-programme"
              className={
                location.pathname === "/internship-programme" ? "active" : ""
              }
              onClick={closeMenu}
            >
              Internship Programme
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/tutor-programme"
              className={
                location.pathname === "/tutor-programme" ? "active" : ""
              }
              onClick={closeMenu}
            >
              Tutor Programme
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/about"
              className={location.pathname === "/about" ? "active" : ""}
              onClick={closeMenu}
            >
              About Us
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/contact"
              className={location.pathname === "/contact" ? "active" : ""}
              onClick={closeMenu}
            >
              Contact
            </Nav.Link>

            <Button
              className="skilledition-main-header-join-btn d-flex align-items-center gap-2"
              onClick={() => navigate("/signin")}

              //   onClick={() => {
              //   closeMenu();
              //   window.open("https://wa.me/918143879627", "_blank");
              // }}
            >
              {/* <FaWhatsapp /> */}
              Register Now
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
